import {IconRetry} from '@wandb/weave/components/Icon';
import React from 'react';

import {AccountIcon} from '../../../pages/Billing/AccountSettings/AccountIcon';
import {AccountType} from '../../../pages/Billing/AccountSettings/util';
import {maybePluralize} from '../../../util/uihelpers';
import {AccountSelectorValue} from './AccountSelectorContextProvider';
import * as S from './ProfileMenu.styles';

type AccountSelectorMenuItemProps = {
  account: AccountSelectorValue | null;
  isSelectedAccount: boolean;
};

export function AccountSelectorMenuItem({
  account,
  isSelectedAccount,
}: AccountSelectorMenuItemProps): JSX.Element {
  const memberCountText =
    ' · ' + maybePluralize(account?.memberCount ?? 0, 'user');

  if (account == null) {
    return <></>;
  }
  return (
    <>
      <S.ProfileMenuAccountContainer>
        <S.ProfileMenuAccountButton>
          <AccountIcon
            accountType={account?.accountType}
            isProfileMenu={true}
            isSelectedAccount={isSelectedAccount}
          />
          <S.ProfileMenuAccountTextContainer>
            <S.ProfileMenuAccountName>
              {account?.accountType === AccountType.Personal
                ? 'Personal'
                : account?.name}
            </S.ProfileMenuAccountName>
            <S.ProfileMenuAccountInfo>
              {account?.accountType === AccountType.Personal
                ? 'Free'
                : account?.accountType + memberCountText}
            </S.ProfileMenuAccountInfo>
          </S.ProfileMenuAccountTextContainer>
        </S.ProfileMenuAccountButton>
      </S.ProfileMenuAccountContainer>
      {!isSelectedAccount && (
        <S.ProfileMenuRetryIcon>
          <IconRetry />
        </S.ProfileMenuRetryIcon>
      )}
    </>
  );
}
